import store from '@/store'
import {MessageBox} from 'element-ui';
import {Message} from 'element-ui';

//删除数据
const del = async (params, that, method) => {
    MessageBox.confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(async () => {
        that.loading = true;
        let param = {
            url: params.url,
            param: params.param
        }
        const data = await store.dispatch('pubMethod', param)

        if (data.infoCode === "0") {
            Message({message: '删除成功', type: 'success'});
            method();
        } else {
            // Message({message: '记录有误或者无法删除', type: 'error'});
        }
        that.loading = false;
    }).catch(() => {

    })
}

export default {
    del
}